import {translate} from "../../../../../translate/translate";
import {Grid, Typography} from "@mui/material";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";

const MapLogHomeComponent = () => {
    return (
        <div className="bg-home">
            <div className="floating-title title-home">
                <Typography variant={"h5"}>MapLog</Typography>
            </div>
            <div>
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    className="grid-container">
                    <Grid>
                        <ConstructionOutlinedIcon sx={{fontSize: 60}} color="disabled"/>
                    </Grid>
                    <Grid>
                        <Typography style={{paddingTop: "8px"}} variant={"h5"}>
                            {translate.t("module_under_construction")}
                        </Typography>
                    </Grid>
                    <Grid>
                        <Typography variant={"body1"} color="text.secondary">
                            {translate.t("module_under_construction_description")}
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default MapLogHomeComponent;
